module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-white-2-f783d2cf89e8548a393fffe8413cd991.png";